<template>
  <div>
    <b-form-group class="mb-1">
      <b-input-group>
        <b-form-input
          v-model="localFilter"
          placeholder="Recherche"
        ></b-form-input>
        <b-input-group-append>
          <b-button :disabled="!localFilter" @click="clearFilterItems"
            ><i class="fas fa-times"></i
          ></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-table
      sticky-header
      responsive
      striped
      hover
      bordered
      :items="filterItems()"
      :fields="localFields"
      selectable
      select-mode="multi"
      selectedVariant="success"
      @row-clicked="toggleItem"
      @row-selected="selectedItems"
      ref="tableItems"
    >
      <template #head(ANA_LIB)="data">
        {{ data.label }}
        <b-form-checkbox
          class="float-right"
          v-model="checkedItems"
          :indeterminate="indeterminateItems"
        >
        </b-form-checkbox>
      </template>
      <!-- tbody-class="acl-tbody-b-block-tr-td" -->
      <!-- Dans le cas d'une serie d'analyses -->
      <template #cell(SER_LIB)="row">
        {{ row.item.SER_LIB }}
        <div class="float-right">
          <b-form-checkbox
            v-model="row.item._checked"
            :indeterminate="row.item._indeterminate"
            @change="toggleCheckbox(row.item)"
            size="lg"
          >
          </b-form-checkbox>
        </div>
      </template>
      <template #row-details="row">
        <b-table
          striped
          hover
          bordered
          :items="row.item._filteredAnalyses ? row.item._filteredAnalyses : row.item.analyses"
          :fields="localFieldsDetails"
          thead-class="d-none"
          selectable
          select-mode="multi"
          selectedVariant="success"
          @row-selected="selectedItems"
          :ref="`tableItems-${row.item.SER_NUM}`"
        >
        </b-table>
      </template>
      <div slot="table-busy" class="text-center">
        <b-spinner class="align-middle color_green_labco" type="grow" />
      </div>
    </b-table>
  </div>
</template>

<script>

function buildNameRefTable (item) {
  return `tableItems-${item.SER_NUM}`
}

function getIndexItem (items, item) {
  return items.findIndex((i) => {
    return i === item
  })
}

export default {
  name: 'selectedAnalysesTableComponent',
  props: {
    // Valeurs séléctionné
    value: {
      type: Array
    },
    // items peut être des analyses ou des series d'analyses
    items: {
      type: Array,
      required: true
    },
    hasItemDetail: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localItems: [],
      localHasItemDetail: false,
      checkedItems: false,
      indeterminateItems: false,
      localFilter: '',
      localFields: [],
      localFieldsDetails: [{
        key: 'ANA_NUM',
        label: 'Ref'
      },
      {
        key: 'ANA_LIB',
        label: 'Analyses à réаliser'
      }]
    }
  },
  mounted: function () {
    const vm = this

    vm.buildLocalFields()
    vm.buildLocalItems()
    vm.buildLocalHasItemDetail()
  },
  methods: {
    buildLocalFields (detail = false) {
      const vm = this

      vm.localFields = vm.localFieldsDetails

      if (vm.hasItemDetail && detail === false) {
        vm.localFields = [
          {
            key: 'SER_LIB',
            label: `Série d'analyses`
          }
        ]
      }
    },
    buildLocalHasItemDetail () {
      const vm = this

      vm.localHasItemDetail = vm.hasItemDetail
    },
    buildLocalItems () {
      const vm = this

      vm.localItems = vm.items.map((item) => ({
        ...item,
        analyses: item.analyses ? [...item.analyses] : [],
        _checked: false,
        _indeterminate: false,
        _showDetails: false
      }))
    },
    selectedItems (items) {
      const vm = this
      let selected = items

      // Dans le cas d'item avec du détail, on prend tous les lignes séléctionné de tous les items
      if (vm.localHasItemDetail === true) {
        selected = []

        for (const item of vm.localItems) {
          const refName = buildNameRefTable(item)
          const selectedItem = []
          item._indeterminate = false

          if (vm.$refs[refName]) {
            // Liste réellement affichée dans le tableau détaillé
            const displayedAnalyses = item._filteredAnalyses || item.analyses

            // Reset des états _checked sur toutes les analyses d'origine
            for (const ana of item.analyses) {
              ana._checked = false
            }

            // Parcours des lignes affichées (index cohérent avec isRowSelected)
            for (let i = 0; i < displayedAnalyses.length; i++) {
              const analyse = displayedAnalyses[i]
              if (vm.$refs[refName].isRowSelected(i)) {
                analyse._checked = true
                selected.push(analyse)
                selectedItem.push(analyse)
              }
            }

            // Vérifie si toutes les analyses (pas seulement filtrées) sont sélectionnées
            const allSelected = item.analyses.length > 0 && item.analyses.every(a => a._checked)
            if (allSelected) {
              vm.selectedItem(item)
            } else if (selectedItem.length > 0) {
              // Partiel -> indéterminé
              const indexItem = getIndexItem(vm.localItems, item)
              vm.$refs.tableItems.unselectRow(indexItem)
              item._indeterminate = true
              item._checked = false
            } else {
              vm.unSelectedItemClear(item)
            }
          }
        }
      } else {
        vm.indeterminateItems = false
        if (selected.length === vm.$refs.tableItems.computedItems.length) {
          vm.checkedItems = true
        } else if (selected.length > 0) {
          vm.indeterminateItems = true
        } else {
          vm.checkedItems = false
        }
      }

      vm.$emit('input', selected)
    },
    toggleItem (item) {
      const vm = this

      if (vm.localHasItemDetail === false) {
        return
      }

      if (item._checked) {
        vm.unSelectedItemClear(item)

        if (vm.localHasItemDetail === true) {
          setTimeout(() => {
            item._showDetails = false
          }, 0)
        }
      } else {
        if (vm.localHasItemDetail === true) {
          item._showDetails = true
        }

        setTimeout(() => {
          vm.selectedItem(item)
        }, 0)
      }
    },
    toggleCheckbox (item) {
      const vm = this

      if (!item._checked) {
        vm.unSelectedItemClear(item)
      } else {
        item._showDetails = true

        setTimeout(() => {
          vm.selectedItem(item)
        }, 0)
      }
    },
    selectedItem (item) {
      const vm = this

      const indexItem = getIndexItem(vm.$refs.tableItems.computedItems, item)

      if (indexItem > -1) {
        if (!vm.$refs.tableItems.isRowSelected(indexItem)) {
          vm.$refs.tableItems.selectRow(indexItem)
        }
      }

      item._checked = true

      const refName = buildNameRefTable(item)
      if (vm.$refs[refName]) {
        // If we are in a filtered state (_filteredAnalyses), only select visible subset rows
        if (item._filteredAnalyses) {
          for (let i = 0; i < item._filteredAnalyses.length; i++) {
            vm.$refs[refName].selectRow(i)
          }
        } else {
          vm.$refs[refName].selectAllRows()
        }
      }
    },
    unSelectedItemClear (item) {
      const vm = this

      const indexItem = getIndexItem(vm.$refs.tableItems.computedItems, item)

      setTimeout(() => {
        vm.$refs.tableItems.unselectRow(indexItem)
      }, 0)

      item._checked = false

      const refName = buildNameRefTable(item)
      if (vm.$refs[refName]) {
        vm.$refs[refName].clearSelected()
      }
    },
    filterItems () {
      const vm = this

      if (vm.localFilter.trim() === '') {
        // Reset any temporary filtered analyses when filter is cleared
        vm.localItems.forEach(item => { delete item._filteredAnalyses })
        return vm.localItems
      }

      const filter = vm.localFilter.toLowerCase()
      const norm = (v) => String(v == null ? '' : v).toLowerCase()

      if (vm.localHasItemDetail) {
        const result = []
        for (const item of vm.localItems) {
          // Always work on original object (no cloning) to keep selection references stable
          delete item._filteredAnalyses

          const filteredAnalyses = item.analyses.filter((analysis) =>
            norm(analysis.ANA_LIB).includes(filter) ||
            norm(analysis.ANA_NUM).includes(filter)
          )
          const serieLibMatches = norm(item.SER_LIB).includes(filter)
          const serieNumMatches = norm(item.SER_NUM).includes(filter)
          const serieMatches = serieLibMatches || serieNumMatches

          // If either the series matches or some analyses match, include the item
          if (serieMatches || filteredAnalyses.length > 0) {
            // Si la série ne match pas mais que des analyses matchent, on filtre
            if (!serieMatches && filteredAnalyses.length > 0) {
              item._filteredAnalyses = filteredAnalyses
            } else if (serieMatches) {
              // Si la série match, on montre toutes les analyses
              delete item._filteredAnalyses
            }
            item._showDetails = true
            result.push(item)
          }
        }
        return result
      }

      return vm.localItems.filter((item) =>
        norm(item.ANA_LIB).includes(filter) ||
        norm(item.ANA_NUM).includes(filter)
      )
    },
    clearFilterItems () {
      const vm = this

      vm.localFilter = ''
    },
    initFilter () {
      const vm = this

      vm.localFilter = ''
    }
  },
  watch: {
    items: function () {
      const vm = this

      if (vm.items.length === 0) {
        vm.checkedItems = false
      }

      vm.buildLocalItems()
    },
    checkedItems: function () {
      const vm = this

      if (vm.checkedItems === true) {
        vm.$refs.tableItems.selectAllRows()
      } else {
        vm.$refs.tableItems.clearSelected()
      }
    },
    localFilter: function () {
      const vm = this

      if (vm.localFilter === '') {
        vm.clearFilterItems()
      }
    }
  }
}
</script>

<style scoped>
.b-table-sticky-header {
  max-height: calc(100vh - 404px);
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectedAnalysesTableComponent.vue